import WizardNavigationItem from "./WizardNavigationItem"
import useMediaQuery from "../../hooks/useMediaQuery"

export interface WizardNavItemType {
  text: string
  className: string
}

export interface WizardNavigationProps {
  navItems: WizardNavItemType[]
  activeStep: number
  enabledSteps: boolean[]
  handleActiveStep: (activeStep: number) => void
  testid: string
}

const WizardNavigation = ({
  navItems,
  activeStep,
  enabledSteps,
  handleActiveStep,
  testid,
}: WizardNavigationProps) => {
  const isMaxWidthLg = useMediaQuery("(max-width: 1024px)")

  const handleStepClick = (index: number) => {
    if (enabledSteps[index]) {
      handleActiveStep(index + 1)
    }
  }

  if (isMaxWidthLg) {
    return (
      <p className="text-sm text-left uppercase font-body font-bold leading-6 tracking-[0.84px]">
        Step {activeStep} of {navItems.length}
      </p>
    )
  }

  return (
    <div
      className="flex flex-col lg:flex-row items-start gap-2 md:gap-6"
      data-testid={testid}
    >
      {navItems.map((navItem: WizardNavItemType, index: number) => (
        <WizardNavigationItem
          key={navItem.text}
          className={navItem.className}
          text={navItem.text}
          disabled={!enabledSteps[index]}
          onClick={() => handleStepClick(index)}
          active={activeStep === index + 1}
        />
      ))}
    </div>
  )
}

export default WizardNavigation
